import styled from "styled-components"
// import media from "styled-media-query"

export const Container = styled.div`
  height: 100vh;
  width: 100vw;
  /* background: #0e1c26; */
  background: white;
`